const { h, render, Component } = require('preact');

class TradeIn extends Component {
  constructor() {
    super();
  }
  render({order}) {
    if(!order.status.hasTradeInStarted)
      return null
    return (<span class="trade_in_list"> {I18n.translate('js.modules.support.trade_in_started')}</span>);
  }
}
module.exports = TradeIn
